import React from 'react'
import HistogramaIngresoUsuarioView from '../../components/histogramas/HistogramaIngresoUsuarioView'

function HistogramaIngresoPorUsuario () {
  return (
    <div style={{ margin: '2% 0' }}>
      <HistogramaIngresoUsuarioView />
    </div>
  )
}

export default HistogramaIngresoPorUsuario
